import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TEAM } from "@/data/content";
import { PageHero, Breadcrumbs, TestimonialBand, FadeIn } from "@/components/Shared";

export default function Team() {
  return (
    <main data-testid="team-page">
      <PageHero
        eyebrow="Included in The Times Best Law Firm 2026"
        title="Meet The Team"
        lead="With decades of experience in the legal sector, our team of criminal defence experts are here to help you navigate the complexities of criminal law."
      />
      <Breadcrumbs items={[{ label: "Team" }]} />

      <section className="bg-white py-20 sm:py-28 lg:py-32">
        <div className="brand-container">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {TEAM.map((person, i) => (
              <FadeIn key={person.slug} delay={(i % 3) * 0.08} className="h-full">
                <Link
                  to={`/team/${person.slug}`}
                  className="brand-card group flex h-full flex-col"
                  data-testid={`person-card-${person.slug}`}
                >
                  <div className="aspect-[4/3] overflow-hidden bg-brand-pale">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="size-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <h3 className="text-lg font-medium text-brand-navy">{person.name}</h3>
                    <p className="mt-1 text-xs uppercase tracking-[0.18em] text-slate-500">
                      {person.role}
                    </p>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">
                      {person.short}
                    </p>
                    <span className="brand-text-link mt-5 flex items-center gap-2">
                      View profile
                      <ArrowRight className="size-3.5 transition-transform duration-200 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <TestimonialBand />
    </main>
  );
}
